import React from 'react';
import { insuranceProviders } from '../../mock';
import { insuranceLogos } from '../../insuranceLogos';

export const InsuranceSection = () => (
  <section id="insurance" data-testid="insurance-section" className="fade-in-section py-12 md:py-20 px-4 bg-white/80 backdrop-blur-sm relative z-10">
    <div className="container mx-auto">
      <div className="text-center mb-10 md:mb-16">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-darkBrown mb-4">Our Insurances</h2>
        <p className="text-sm md:text-xl text-gray-600 max-w-3xl mx-auto">
          We want you to access our services without worrying about expenses.
        </p>
        <div className="w-24 h-1 bg-primaryOrange mx-auto mt-4"></div>
      </div>

      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-7 gap-3 md:gap-6">
        {insuranceProviders.map((insurance) => {
          const logoKey = insurance.logo.toLowerCase();
          return (
            <a
              key={insurance.name}
              href={insurance.website}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white rounded-lg p-2 md:p-4 flex flex-col items-center justify-center hover:shadow-xl transition-all hover:-translate-y-2 border-2 border-warmBeige hover:border-primaryOrange group min-h-[70px] md:min-h-[100px]"
              title={`Visit ${insurance.name} website`}
            >
              <div className="w-full h-10 md:h-16 flex items-center justify-center">
                <img
                  src={insuranceLogos[logoKey] || insurance.logo}
                  alt={`${insurance.name} logo`}
                  className="max-h-10 md:max-h-16 max-w-full object-contain transition-all"
                />
              </div>
            </a>
          );
        })}
      </div>
    </div>
  </section>
);
